module.exports = __webpack_public_path__ + "img/user-guide-02-03-02.6c1008b0.png";